import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TiltCard from "./TiltCard";

const API_BASE = "https://advancelighting.pt";

export const useCampanhas = () => {
  const [campanhas, setCampanhas] = useState([]);
  const [produtosPorCampanha, setProdutosPorCampanha] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCampanhas = async () => {
      try {
        const res = await fetch(`${API_BASE}/campanhas.php`, { timeout: 5000 });
        if (!res.ok) throw new Error("Falha na resposta da API /campanhas");
        const data = await res.json();

        const hoje = new Date();
        const ativas = data.filter(c => {
          const inicio = new Date(c.startDate);
          const fim = new Date(c.endDate);

          // Ajusta fim da campanha para o final do dia
          fim.setHours(23, 59, 59, 999);

          const ativo = Number(c.ativo);
          return inicio <= hoje && fim >= hoje && ativo === 1;
        });

        setCampanhas(ativas);

        // Buscar produtos de forma segura
        const produtosTemp = {};
        for (const camp of ativas) {
          try {
            const prodRes = await fetch(`${API_BASE}/campanha_produtos.php?id=${camp.id}`);
            if (!prodRes.ok) throw new Error(`Erro em campanha ${camp.id}`);
            const prodData = await prodRes.json();
            produtosTemp[camp.id] = prodData;
          } catch (err) {
            console.warn(`⚠️ Falha ao buscar produtos da campanha ${camp.id}`, err);
            produtosTemp[camp.id] = []; // mantém o site funcionando
          }
        }

        setProdutosPorCampanha(produtosTemp);
      } catch (err) {
        console.error("❌ Erro ao buscar campanhas:", err);
        setCampanhas([]); // evita quebrar o front
        setProdutosPorCampanha({});
      } finally {
        setLoading(false);
      }
    };

    fetchCampanhas();
  }, []);

  return { campanhas, produtosPorCampanha, loading };
};
// ==========================
// 2️⃣ COMPONENTE VISUAL Dos pdfs das campanhas
// ==========================

export const CampanhaCard = ({ camp, produtos = [], i18n }) => {    
return (
      <div className="campanha-card">
    <a href={camp.download} target="_blank" rel="noopener noreferrer">
      <img loading="lazy" src={camp.linkImg} alt={camp[`nameImg_${i18n.language}`]} />
      <div className="item__details">
        <div className="item__details_text">{camp[`nameImg_${i18n.language}`]}</div>
      </div>
    </a>
  </div>
)}

